export default "__VITE_ASSET__eCLhSJH2__"